export const ENROLLMENT_STATUS = {
  INACTIVE: 'inactive',
  ACTIVE: 'active',
  CANCELLED: 'cancelled'
};

export const ENROLLMENT_STATUS_LABELS: Record<string, string> = {
  active: 'Ativo',
  inactive: 'Inativo',
  cancelled: 'Cancelado'
};
